import { render, staticRenderFns } from "./LibraryCollectionList.vue?vue&type=template&id=3cef6ef4&"
import script from "./LibraryCollectionList.vue?vue&type=script&lang=js&"
export * from "./LibraryCollectionList.vue?vue&type=script&lang=js&"
import style0 from "./LibraryCollectionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LibraryCollectionList.vue"
export default component.exports